<template>
  <div class="page-find-password" v-loading="loading" :loading="loading">
    <div class="form-block">
      <p v-if="pageType == 'findPassword'">
        {{ $t("loginPage.findPassword") }}
      </p>
      <p v-else-if="pageType == 'activeUser'">
        {{ $t("pageActiveUser.userActive") }}
      </p>
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item :label="$t('pageActiveUser.username')" prop="username">
          <el-input v-model="form.username" disabled></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('pageActiveUser.passwordSetting')"
          prop="pass"
          class="pwd-item"
        >
          <pwdInput v-model="form.pass" :clearable="false"></pwdInput>
          <!-- <pwdInputForH5 v-model="form.pass" v-else></pwdInputForH5> -->
          <password v-model="form.pass" :strength-meter-only="true" />
        </el-form-item>
        <el-form-item
          :label="$t('pageActiveUser.confirmPassword')"
          prop="checkpass"
        >
          <pwdInput v-model="form.checkpass" :clearable="false"></pwdInput>
          <!-- <pwdInputForH5 v-model="form.checkpass" v-else></pwdInputForH5> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="footerBtnBox">
        <el-button
          size="small"
          type="primary"
          @click="buttonFind()"
          :disabled="submitted"
          v-if="pageType == 'findPassword'"
          >{{ $t("pageActiveUser.findImmediately") }}</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="buttonFind()"
          :disabled="submitted"
          v-else-if="pageType == 'activeUser'"
          >{{ $t("pageActiveUser.activeImmediately") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import pwdInput from "@/components/pwdInput.vue";
import pwdInputForH5 from "@/components/pwdInputForH5.vue";
import Password from "vue-password-strength-meter";
import { isEmpty } from "../utils/utils";
import md5 from "js-md5";
import { clearLocalStorage } from "@/utils/lsClear";
import PwdInputForH5 from "@/components/pwdInputForH5.vue";
export default {
  components: { Password, pwdInput,pwdInputForH5 },
  data() {
    let passwordRule = (rule, value, callback) => {
      var regex = new RegExp(this.pwdConfig.pwdRule);
      if (regex.test(value) == false) {
        callback(
          new Error(this.$t("pwdStrengthRule." + this.pwdConfig.pwdStrength))
        );
      } else {
        this.$refs.form.validateField("checkpass");
        callback();
      }
    };
    let checkPasswordRule = (rule, value, callback) => {
      if (!isEmpty(value)) {
        if (value == this.form.pass) {
          callback();
        } else {
          callback(
            new Error(this.$t("forcePwdChangePromptMessage.diffPassword"))
          );
        }
      } else {
        callback(new Error(" "));
      }
    };
    return {
      form: {
        username: "",
        pass: "",
        checkpass: "",
      },
      rules: {
        username:[{required:true, message:' '}],
        pass: [{ required: true, validator: passwordRule, trigger: "blur" }],
        checkpass: [
          { required: true, validator: checkPasswordRule, trigger: "blur" },
        ],
      },
      pwdConfig: {
        pwdRule: "",
        pwdLength: "18",
        pwdStrength: "",
      },
      randomString: "",
      pageType: "",
      submitted: false,
      loading: true,
      deviceType:'Desktop'
    };
  },
  created() {
    this.deviceType=this.detectDevice()
    this.pageType = this.$route.meta.pageType;
    this.randomString = this.$route.query.randomString;
    this.getUserInfo();
  },
  methods: {
    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // 检测移动设备
      if (/android/i.test(userAgent)) {
          return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }
      // 默认认为是桌面端
      return "Desktop";
    },
    getUserInfo() {
      this.loading = true;
      this.$httpList
        .getFindPasswordUser(this.randomString)
        .then((res) => {
          if (res.resultCode == 1001) {
            this.form.username = res.data.username;
            this.pwdConfig.pwdRule = res.data.rule;
            this.pwdConfig.pwdStrength = res.data.type;
            this.pwdConfig.pwdLength = res.data.maxLength;
            if(res.data.languagePreference){
              this.$actions.setGlobalState({
                currentLanguage: res.data.languagePreference,
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async checkUserPassword(oldPwd) {
      try {
        const res = await this.$httpList.checkUserPassword(oldPwd);
        if (res.resultCode == 1001) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async buttonFind() {
      const valid = await new Promise((resolve) => {
        this.$refs.form.validate((valid) => resolve(valid));
      });
      if (!valid) {
        return;
      }
      this.submitted = true;
      let submitInfo = {
        username: this.form.username,
        newPwd: md5(this.form.pass + this.form.username).toUpperCase(),
        randomString: this.randomString,
      };
      await new Promise((resolve) => {
        this.$httpList
          .updateUserPassword(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              if(this.pageType=='findPassword'){
                this.$notify({
                  message: `${this.$t(
                    "forcePwdChangePromptMessage.changePassword"
                  )}`,
                  type: "success",
                });
              }else{
                this.$notify({
                  message: `${this.$t(
                    "forcePwdChangePromptMessage.activeUserSuccess"
                  )}`,
                  type: "success",
                });
              }
              setTimeout(() => {
                // 修改密码直接退出
                clearLocalStorage();
                // 重定向至登录页面
                let currentUrl = window.location.href;
                let position = currentUrl.indexOf("/#");
                let loginUrl = currentUrl.substring(0, position);
                window.location.href = loginUrl;
              }, 1000);
            }
            resolve(res);
          })
          .finally(() => {
            this.submitted = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-find-password {
  height: 100%;
  padding: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
  .form-block {
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 0px rgba(187, 191, 196, 0.5);
    border: 1px solid rgba(187, 191, 196, 0.5);
    border-radius: 10px;
    background: #fff;
    padding: 30px;
    .title {
      margin-top: 20px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
    }
    .reasonTitle {
      margin-top: 15px;
      text-align: center;
      font-size: 14px;
    }
    .form {
      padding: 2vw;
    }
    .footerBtnBox {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      .el-button {
        border-radius: 8px !important;
      }
    }
  }
  .pwd-item {
    ::v-deep.el-form-item__error {
      margin-top: -20px;
    }
  }
  @media screen and (min-width: 600px) {
    padding: 20px;
    .form-block {
      width: 80%; // 定义固定宽度
    }
    p {
      font-size: 20px;
    }
  }
  @media screen and (min-width: 1024px) {
    padding: 20px;
    .form-block {
      width: 60%; // 定义固定宽度
    }
    p {
      font-size: 20px;
    }
  }
  @media screen and (min-width: 1440px) {
    padding: 20px;
    .form-block {
      width: 500px; // 定义固定宽度
    }
    p {
      font-size: 20px;
    }
  }
}
::v-deep .is-error .el-input.is-disabled .el-input__inner{
  border-color: #DE5358!important;
}
</style>
